import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 312.9 66.7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M187.4 17.8c-3.6 2-9.5 7.5-16.2 15.1 8.5 8.6 18.2 19.7 28.7 33.8 16.5-22.2 27.4-37.7 35.2-43.5 7.8-5.7 33.2-13.2 77.8-20.7-67.1 6.1-115.4 9.9-125.5 15.3",
      style: {"fill":"#5aa92e"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M150.3 14.5C139.4 6.6 77.9 1.9 0 0c37.3 5.6 85 13.6 98.8 22.2 10.9 6.9 22.9 19.8 43.2 43.3l57.8 1.2c-20.6-27.9-38.4-44.2-49.5-52.2",
      style: {"fill":"#00613f"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "WF-logo"}) } }